export default {
  tableLoading(state, value) {
    state.tableLoading = value;
  },
  trainings(state, value) {
    state.trainings = value;
  },
  currentTraining(state, value) {
    state.currentTraining = value;
  },
  total(state, value) {
    state.total = value;
  },
  currentPage(state, value) {
    state.currentPage = value;
  },
  perPage(state, value) {
    state.perPage = value;
  },
  searchQuery(state, value) {
    state.searchQuery = value;
  },
};
